import { ProductCard, ProductListItem } from './types';
import { http_get, http_put, http_delete } from './helpers';
import { version } from './config';

// PUT /api/v{version}/m/User/Products
// 用户收藏某个产品
export const putUserProductCollect = http_put<
    {
        productId: string; // 产品的ID
        pvId: string;
    }[],
    void
>(`/api/v${version}/m/User/Products`);

// DELETE /api/v{version}/m/User/Products
// 用户取消收藏某个产品
export const deleteUserProductCollect = http_delete<
    {
        productId: string; // 产品的ID
    }[],
    void
>(`/api/v${version}/m/User/Products`);

// GET /api/v{version}/m/User/Products/Collected
// 已收藏产品列表
export const getUserProductsCollected = http_get<
    {
        MaxResultCount?: number;
        SkipCount?: number;
    },
    {
        totalCount: number;
        items: ProductCard[];
    }
>(`/api/v${version}/m/User/Products/Collected`);

// GET /api/v{version}/m/User/Products/ToBeUpdated
// 待更新产品列表
export const getUserProductsToBeUpdated = http_get<
    void,
    ProductListItem[]
>(`/api/v${version}/m/User/Products/ToBeUpdated`);

// GET /api/v{version}/m/User/Products/Downloaded
// 已下载产品列表
export const getUserProductsDownloaded = http_get<
    void,
    ProductListItem[]
>(`/api/v${version}/m/User/Products/Downloaded`);
